var React = require('react');

function ES (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#FFDA44","d":"M0 85.331h512v341.337H0z","key":0}),React.createElement("g",{"fill":"#D80027","key":1},React.createElement("path",{"d":"M0 85.331h512v113.775H0zM0 312.882h512v113.775H0z"}))]);
}

ES.defaultProps = {"viewBox":"0 85.333 512 341.333"};

module.exports = ES;

ES.default = ES;
